// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react"
import { classNames } from "@plasmicapp/react-web"

export function CoolDots51Icon(props) {
  const { className, style, title, ...restProps } = props
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 70 70"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",
        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <circle
        cx={"2.903"}
        cy={"2.903"}
        r={"2.903"}
        fill={"currentColor"}
        fillOpacity={".29"}
      ></circle>

      <circle
        cx={"2.903"}
        cy={"18.867"}
        r={"2.903"}
        fill={"currentColor"}
        fillOpacity={".29"}
      ></circle>

      <circle
        cx={"18.867"}
        cy={"2.903"}
        r={"2.903"}
        fill={"currentColor"}
        fillOpacity={".29"}
      ></circle>

      <circle
        cx={"18.867"}
        cy={"18.867"}
        r={"2.903"}
        fill={"currentColor"}
        fillOpacity={".29"}
      ></circle>

      <circle
        cx={"34.832"}
        cy={"2.903"}
        r={"2.903"}
        fill={"currentColor"}
        fillOpacity={".29"}
      ></circle>

      <circle
        cx={"34.832"}
        cy={"18.867"}
        r={"2.903"}
        fill={"currentColor"}
        fillOpacity={".29"}
      ></circle>

      <circle
        cx={"50.796"}
        cy={"2.903"}
        r={"2.903"}
        fill={"currentColor"}
        fillOpacity={".29"}
      ></circle>

      <circle
        cx={"50.796"}
        cy={"18.867"}
        r={"2.903"}
        fill={"currentColor"}
        fillOpacity={".29"}
      ></circle>

      <circle
        cx={"50.796"}
        cy={"34.832"}
        r={"2.903"}
        fill={"currentColor"}
        fillOpacity={".29"}
      ></circle>

      <circle
        cx={"50.796"}
        cy={"50.797"}
        r={"2.903"}
        fill={"currentColor"}
        fillOpacity={".29"}
      ></circle>

      <circle
        cx={"50.796"}
        cy={"66.761"}
        r={"2.903"}
        fill={"currentColor"}
        fillOpacity={".29"}
      ></circle>

      <circle
        cx={"66.761"}
        cy={"2.903"}
        r={"2.903"}
        fill={"currentColor"}
        fillOpacity={".29"}
      ></circle>

      <circle
        cx={"66.761"}
        cy={"18.867"}
        r={"2.903"}
        fill={"currentColor"}
        fillOpacity={".29"}
      ></circle>

      <circle
        cx={"66.761"}
        cy={"34.832"}
        r={"2.903"}
        fill={"currentColor"}
        fillOpacity={".29"}
      ></circle>

      <circle
        cx={"66.761"}
        cy={"50.797"}
        r={"2.903"}
        fill={"currentColor"}
        fillOpacity={".29"}
      ></circle>

      <circle
        cx={"66.761"}
        cy={"66.761"}
        r={"2.903"}
        fill={"currentColor"}
        fillOpacity={".29"}
      ></circle>
    </svg>
  )
}

export default CoolDots51Icon
/* prettier-ignore-end */
